import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../../components/button'
import { Loader } from '../../../../../components/loader'
import { PageContainer } from '../../../../../components/page-container/page-container'
import { Pin } from '../../../../../components/pin'
import { showToast } from '../../../../../components/sonner'
import type { RootState } from '../../../../../redux/global-store'
import { paths } from '../../../../../router/paths'
import { validateTokenRequest, resetPasswordUpdateState, resetPasswordResetState } from '../../../presentation/redux/actions/reset-password-actions'

export const ValidateToken = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [token, setToken] = useState('')

  const load = useSelector((state: RootState) => state.user.resetPassword.load)
  const error = useSelector((state: RootState) => state.user.resetPassword.error)
  const tokenValidated = useSelector((state: RootState) => state.user.resetPassword.tokenValidated)
  const resetPasswordFlow = useSelector((state: RootState) => state.user.resetPassword.resetPasswordFlow)

  const handleContinue = () => {
    // Salva o token no estado para usar no resetPassword
    dispatch(resetPasswordUpdateState({ token: token }))
    
    // Valida token usando o taxId salvo no estado
    dispatch(
      validateTokenRequest({
        TaxId: resetPasswordFlow.taxId,
        Code: token,
      })
    )
  }

  // Listen for successful token validation
  useEffect(() => {
    if (tokenValidated) {
      navigate(paths.user.resetPassword.createNewPin)
    }
  }, [tokenValidated, navigate])

  // Show error messages
  useEffect(() => {
    if (error) {
      showToast(error, 'error')
    }
  }, [error])

  return (
    <PageContainer
      type="unauthenticated"
      footerClass='flex w-full flex-col items-center justify-between gap-12 px-8'
      footer={
        <div className="flex w-full flex-col items-center py-12">
          {load && <Loader />}
          <Button
            className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
            onClick={handleContinue}
            disabled={token.length !== 6 || load}
          >
            {load ? 'Validando...' : 'Continuar'}
          </Button>
          <Button
            variant="outlined"
            className="h-[55px] w-full rounded-[10px] text-xl font-semibold mt-4"
            onClick={() => {
              dispatch(resetPasswordResetState())
              navigate(paths.user.resetPassword.informTaxId)
            }}
            disabled={load}
          >
            Regresar
          </Button>
        </div>
      }
    >
      <div className="flex w-full flex-col items-center justify-between gap-12 px-8">
        <div className="flex w-full flex-col gap-2 pt-8">
          <p className="pb-2 text-lg font-normal">Recuperar PIN</p>
          <p className="pb-6 text-sm font-normal text-[#5A5A5A]">
            Se ha enviado un token de autenticación a través de correo
            electrónico/SMS. Ingresa el número en el campo a continuación.
          </p>
          <div className="flex flex-col gap-8">
            <Pin onChange={setToken} type="token" />
          </div>
        </div>
      </div>
    </PageContainer>
  )
}
